export const parlorManagedTypeDescription = {
  전문: "많은 비용 부담은 들지 않으면서 어느 정도 시설이 나쁘지 않은 수준의 장례식장",
  대학병원:
    "비용 부담이 조금 있더라도 쾌적하고 고급스러운 장례식장을 원하시는 분들이 많이 찾는 장례식장",
  공설: "다른 전문 장례식장이나 대학병원장례식장에 비해 비용이 매우 저렴하나, 그 수가 적은 장례식장",
};
